var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    preserveAspectRatio: "xMidYMid meet",
    style: {
      enableBackground: "new 0 0 374.1 289.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.0789,
    y1: -853.7525,
    x2: -3.043,
    y2: -853.7525,
    gradientTransform: "matrix(-8.480000e-02 0.9964 -0.9964 -8.480000e-02 -545.3154 26.3318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#FFa0a0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAFeFa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M318.7,93.2c13.1-4.2,14.8-4.2,17.5-6.8c1.5-1.5,3.6-3.6,3.6-6.5c0-3.6-2.4-6.8-5.3-8.3 c-3.3-1.8-6.8-0.9-9.5,0c-5.3,1.5-13.4,3.9-22.6,6.8c-7.4-4.5-14.6-8.6-22-13.1c-1.8,2.1-3.6,4.5-5.6,6.5c4.5,5,18.4,20.8,26.7,23.2 c0.6,0.3,1.2,0.3,1.2,0.3C308.6,96.4,313,94.9,318.7,93.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182497347732454193650000006141591556395045552_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6,
    y1: 759.5691,
    x2: 310,
    y2: 759.5691,
    gradientTransform: "matrix(1 0 0 1 0 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182497347732454193650000006141591556395045552_)"
    },
    d: "M299.3,29.2h-267 c-5.9,0-10.7,4.8-10.7,10.7v183c0,5.9,4.8,10.7,10.7,10.7h272c3.1,0,5.7-2.5,5.7-5.7V39.8C309.9,34,305.2,29.2,299.3,29.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "295,57.3 36.5,57.3 36.5,57.3 36.5,44.5 295,44.5 295,44.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M36.5,66.6v150.2c0,1.6,1.3,3,3,3H292c1.6,0,3-1.3,3-3V68c0-0.7-0.6-1.3-1.3-1.3L36.5,66.6 L36.5,66.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#494948"
    },
    d: "M289.1,50.9c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1S289.1,49.2,289.1,50.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005258061358977549060000004644803824441406856_",
    gradientUnits: "userSpaceOnUse",
    x1: 16,
    y1: 870.2191,
    x2: 335.8,
    y2: 870.2191,
    gradientTransform: "matrix(1 0 0 1 0 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005258061358977549060000004644803824441406856_)"
    },
    d: "M330.1,233.6H21.8 c-3.2,0-5.8,2.5-5.8,5.7v1.3c0,5.5,4.5,9.9,10.1,9.9l303.2-0.7c5.6,0,6.5-3.8,6.5-9.2v-1.3C335.8,236.1,333.3,233.6,330.1,233.6z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083767244114555747300000016707271501706759080_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.699,
    y1: 1029.4225,
    x2: 475.564,
    y2: 1029.4225,
    gradientTransform: "matrix(0.9999 -1.515037e-02 1.515037e-02 0.9999 -279.5674 -948.7277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F6A946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F16B46"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083767244114555747300000016707271501706759080_)"
    },
    d: "M168.7,133.8 c27.9-31.3,37.5-55.3,41.2-67.1c0.6-2.4,1.7-6.1,1.7-11c-1.3-23.5-20.9-41.9-44.7-41.4S124.1,33.7,123.6,57c0.2,5,1.3,8.5,2.2,10.7 C129.4,79.9,139.8,103.4,168.7,133.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179624266843191216750000001705324949165569184_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.8111,
    y1: 1009.8663,
    x2: 464.4704,
    y2: 1009.8663,
    gradientTransform: "matrix(0.9999 -1.515037e-02 1.515037e-02 0.9999 -279.5674 -948.7277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F16B46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#F6A946"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000179624266843191216750000001705324949165569184_)"
    },
    cx: 167.2,
    cy: 54.5,
    r: 32.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.9,50.3c-2-12.4-13-21.9-26-21.8c-14.4,0.4-25.7,11.9-25.7,26.2l0,0 c0.4,14.4,11.9,25.7,26.2,25.7c14.4-0.4,25.7-11.9,25.7-26.2C193.4,52.8,193.1,51.7,192.9,50.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M312.2,269.9c-0.6-5-1.5-9.8-2.1-14.8l8.3-0.9c-0.6,5.3-0.9,10.7-1.5,16 C315.4,270.1,313.9,270.1,312.2,269.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066478781897756905050000013117065344865670821_",
    gradientUnits: "userSpaceOnUse",
    x1: -1391.8156,
    y1: 1333.8591,
    x2: -1371.3429,
    y2: 1333.8591,
    gradientTransform: "matrix(0.9339 -0.3574 0.3574 0.9339 1122.1987 -1467.031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F7AA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F46B45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066478781897756905050000013117065344865670821_)"
    },
    d: "M305.9,274.9c-2.7,0-4.8,0.3-7.4,0 c0.3-0.3,0.3-0.6,0.6-0.6c3.6-2.1,6.2-3.9,7.7-5l2.7-1.5c1.2-0.6,1.8-1.2,2.7-0.9c0.6,0.3,0.6,0.3,1.2,0.9c0.3,0.3,1.2,0.6,2.1,0.3 c0.9-0.3,1.2-0.9,1.2-1.2c0,0,3,1.5,2.1,6.2c-0.6,0.3-1.8,0.3-3,0.6C311.9,274.6,308.9,274.9,305.9,274.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M298.5,274.9c2.7,0.3,4.8,0,7.4,0s5.6-0.3,9.5-0.9c1.2-0.3,2.1-0.6,3-0.6c0,0,1.2,1.5-0.6,2.7 l-19.3,0.6c0,0-0.3-0.6-0.3-1.2C298.5,275.2,298.5,274.9,298.5,274.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167355029583754766360000014432962607601648031_",
    gradientUnits: "userSpaceOnUse",
    x1: -1717.641,
    y1: 891.2575,
    x2: -1738.2992,
    y2: 761.5701,
    gradientTransform: "matrix(-1 0 0 1 -1408.3442 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2593,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7759,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167355029583754766360000014432962607601648031_)"
    },
    d: "M352.2,118.7c-13.4,0.9-26.4,1.5-39.8,2.4 c-3.6,17.5-6.5,38-7.7,60.9c-1.5,31.2,1.2,58.5,4.8,80.5c3.3,0,6.5,0,9.8,0c5.3-26.1,11.3-52.9,17.5-80.2 C341.8,160.9,346.9,139.5,352.2,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M349.6,270.4c-0.6-5-1.5-9.8-2.1-14.8l8.3-0.9c-0.6,5.3-0.9,10.7-1.5,16 C352.5,270.7,351.1,270.7,349.6,270.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057837938998713148450000012471899747858217654_",
    gradientUnits: "userSpaceOnUse",
    x1: -1355.5917,
    y1: 1348.6378,
    x2: -1336.906,
    y2: 1348.6378,
    gradientTransform: "matrix(0.9339 -0.3574 0.3574 0.9339 1122.1987 -1467.031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F7AA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F46B45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057837938998713148450000012471899747858217654_)"
    },
    d: "M344.5,275.8c-2.4,0-4.2,0.3-6.8,0 c0-0.3,0.3-0.3,0.3-0.6c3.3-2.1,5.6-3.6,7.1-4.5l2.4-1.2c1.2-0.6,1.8-0.9,2.4-0.9s0.3,0.3,1.2,0.6c0.3,0,0.9,0.6,1.8,0.3 c0.6-0.3,1.2-0.9,1.2-0.9s2.7,1.5,1.8,5.6c-0.6,0.3-1.5,0.3-2.7,0.6C349.9,275.5,346.9,275.5,344.5,275.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M337.7,275.8c2.4,0.3,4.2,0,6.8,0s5.3-0.3,8.9-0.9c1.2-0.3,2.1-0.3,2.7-0.6c0,0,1.2,1.2-0.6,2.4 l-17.5,0.6c0,0-0.3-0.6,0-1.2C337.7,275.8,337.7,275.8,337.7,275.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044878731064995670560000008595372180716696732_",
    gradientUnits: "userSpaceOnUse",
    x1: -1743.142,
    y1: 755.4291,
    x2: -1765.6586,
    y2: 892.7808,
    gradientTransform: "matrix(-1 0 0 1 -1408.3442 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C06C84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2593,
    style: {
      stopColor: "#A36681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5238,
    style: {
      stopColor: "#8C6180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7759,
    style: {
      stopColor: "#7F5E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A5D7E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044878731064995670560000008595372180716696732_)"
    },
    d: "M354,122.6c-0.6-1.5-1.8-3.9-3.9-6.5 c-12.2,0.3-24.4,0.9-36.8,1.2c1.5,10.4,3.3,24.1,6.2,39.5c3.6,19.3,6.8,33.6,9.5,44.8c5.3,22.6,11,44,16.9,64.1 c3.3-0.3,6.5-0.9,9.8-1.2c0-12.8,0.3-26.1,0.6-39.5c0.3-9.5,0.6-19,1.2-28.5c0,0,0.6-13.1-2.1-65c0-0.6,0-1.2-0.3-2.1 C355.2,127.6,354.9,125.2,354,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M336.5,62.6c-1.5-0.3-3.9-0.3-6.8,0.6c-2.1,0.6-3.6,1.5-4.5,2.1c0,2.4,0,4.8,0,7.1 c1.2,0.6,3.9,1.5,7.1,1.2c2.7-0.3,4.5-1.2,5.6-1.8C337.4,68.8,337.1,65.5,336.5,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29EA4"
    },
    d: "M325.2,66.4c0-0.3,0.3-0.6,0.3-0.9c0.6-0.6,2.1-1.5,4.2-1.8c1.2-0.3,2.1,0,3,0 c-0.3,0.9-1.2,2.7-3,3.9c-1.8,1.5-3.6,1.8-4.5,1.8C325.2,68.5,325.2,67.6,325.2,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA5842"
    },
    d: "M320.2,47.4c0,0-3-2.7-1.2-5.6c2.4-4.8,18.7-7.1,24.1,1.2c3.9,5.9,1.5,16-6.8,22 C330.9,59.3,325.5,53.4,320.2,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M320.2,47.4c-0.3,1.8-0.3,3.3-0.3,4.5s0,1.8,0,3.3c0,4.5-0.3,4.5,0,6.5c0.3,3.6,0.3,5.3,1.8,6.2 c1.5,1.2,3.6,0.6,6.5-0.3c2.1-0.6,3.6-0.9,5-2.4c1.8-1.8,2.1-3.6,2.4-4.5c0,0,0.6,1.2,1.2,0.3c0.9-0.9,2.7-5.9,0.6-6.2 s-2.7,2.4-2.7,2.4l-1.5-1.2c0,0,1.2-6.2-1.5-7.7c-0.6-0.3-1.2-0.3-1.5-0.3C327.9,47.7,324.9,47.7,320.2,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M323.1,61.7c0,1.8-1.5,3-3,3v-0.3c0-0.3,0-0.6,0-0.6c0-0.6,0-1.8,0-2.1 C321.1,61.7,322,61.7,323.1,61.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023987598448160919260000017739612176599048845_",
    gradientUnits: "userSpaceOnUse",
    x1: -1537.5979,
    y1: 757.3093,
    x2: -1564.7126,
    y2: 709.4943,
    gradientTransform: "matrix(-1 0 0 1 -1211.5635 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F7AA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F46B45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023987598448160919260000017739612176599048845_)"
    },
    d: "M324,113.9l8.3-8.3l8,8l7.4-7.4l4.8,4.8 c0.6,3,0.9,6.8,1.5,11.3c-5.3,0.6-11,0.9-16.9,1.2c-9.2,0-17.5-0.6-24.6-1.5c0.9-5.3,1.5-10.4,2.4-15.7l0.9-0.9L324,113.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159427899007960835260000007032234716848972725_",
    gradientUnits: "userSpaceOnUse",
    x1: -1525.726,
    y1: 750.3889,
    x2: -1552.6381,
    y2: 702.9305,
    gradientTransform: "matrix(-1 0 0 1 -1211.5635 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F7AA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F46B45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159427899007960835260000007032234716848972725_)"
    },
    d: "M340.1,102.4l-8-8l-8.3,8.3l-7.7-7.7 c1.2-7.1,2.4-14.3,3.6-21.4c0.9-0.6,2.4-0.9,3.6-1.5c0.6-0.3,1.2-0.3,1.8-0.3c2.4,0.3,4.8,0.3,6.8,0.6c2.4-0.3,4.2-0.9,5.3-1.5 c0.9,0,1.8,0.3,3,0.6c1.5,0.3,2.4,0.6,3.3,0.9c0.6,0.3,1.8,0.9,3,2.4c1.2,3,1.8,5.3,2.1,7.1c0.6,4.2,0,6.8,0.9,12.8 c0.3,1.2,0.3,2.4,0.6,3l-2.7-2.7L340.1,102.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019672155274681931670000003428048882236896642_",
    gradientUnits: "userSpaceOnUse",
    x1: -1764.2108,
    y1: 732.6409,
    x2: -1720.0972,
    y2: 732.2106,
    gradientTransform: "matrix(-1 0 0 1 -1408.3442 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3548,
    style: {
      stopColor: "#F7AA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F46B45"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019672155274681931670000003428048882236896642_)"
    },
    d: "M323.7,102.7l8.3-8.3l8,8l7.4-7.4l2.7,2.7 c0,0.6,0.3,0.9,0.3,1.5c0.6,4.5,1.2,6.5,1.2,7.7c0.3,1.2,0.3,2.7,0.6,4.2l-4.8-4.8l-7.1,7.7l-8-8l-8.3,8l-8.6-8.6l-0.9,0.9 c0.6-3.9,1.2-7.4,1.5-11.3L323.7,102.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC0C2"
    },
    d: "M335,134.7c-0.6-0.3-1.2-0.6-2.1-0.3c-0.3,0-0.6,0.3-2.4,1.5c0,0-0.9,0.6-2.4,2.4 c-0.3,0.3-0.6,0.6-0.6,1.2c0,0.3,0.3,0.6,0.6,0.6c0.3,0.3,0.9,0,1.2-0.3c0.9-0.6,1.5-1.2,2.4-1.8c-1.5,2.1-3.3,4.5-4.8,6.5 c-0.3,0.3-0.3,0.9,0.3,1.2c0.3,0.3,0.9,0.3,1.2,0c0.9-1.2,2.1-2.4,3-3.6c-0.9,1.2-1.5,2.7-2.4,3.9c-0.3,0.3-0.3,0.9,0,1.2 s0.9,0.3,1.5,0c0.9-1.2,1.8-2.4,2.7-3.6c-0.6,1.2-1.5,2.7-2.1,3.9c-0.3,0.3,0,0.9,0.3,1.2s1.2,0.3,1.5-0.3c0.9-1.2,1.5-2.4,2.4-3.6 c-0.6,1.2-1.5,2.4-2.1,3.6c0,0.3,0.3,0.6,0.6,0.9c0.3,0.3,0.6,0,0.9,0c2.7-4.2,4.8-7.1,5.3-8c0.3-0.3,0.6-0.9,0.6-1.5 c0-0.9,0-1.5-0.3-1.8c0.6-0.6,0.9-0.9,1.5-1.5l-4.8-3.3C335.9,133.5,335.3,134.1,335,134.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129906343307206597570000008925068751062857650_",
    gradientUnits: "userSpaceOnUse",
    x1: 349.8624,
    y1: 769.7294,
    x2: 347.0387,
    y2: 705.9171,
    gradientTransform: "matrix(1 0 0 1 0 -628.1691)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F46B45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6452,
    style: {
      stopColor: "#F7AA46"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129906343307206597570000008925068751062857650_)"
    },
    d: "M357.9,91.1c-5.6-12.5-6.2-14.3-8.9-16.6 c-1.5-1.2-3.9-3-7.1-2.7c-3.6,0.3-6.5,3.3-7.4,6.2c-1.2,3.6,0,6.8,1.2,9.5c2.4,5.6,5.3,13.1,9.8,22c-3.3,7.7-6.8,15.7-10.1,23.5 c2.4,1.5,4.8,3,7.1,4.8c4.5-5,18.4-21.1,19.6-29.4c0-0.6,0.3-1.5,0.3-1.5C362.3,100.9,360.6,96.7,357.9,91.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000081623344392684334060000004378968281493574555_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M158.2,209l-0.5-52.3l3.4-0.1l0.5,52.3c-0.1,0.8-0.5,1.6-1.4,1.6h-0.4 C159,210.2,158.2,209.8,158.2,209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M120.3,213.2l-0.7-56.3l3.4-0.1l0.7,56.3c-0.1,0.8-0.5,1.6-1.4,1.6l-0.8-0.1 C120.6,215,119.8,214,120.3,213.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M113.1,210.9l-0.5-52.3l4-0.1l0.5,52.3c-0.1,0.8-0.5,1.6-1.4,1.6h-0.4 C114.3,212.4,113.1,211.9,113.1,210.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M111.6,159.4l-0.1-14.7c0-0.4,0.4-0.4,0.5-0.8l55-0.8c0.4,0,0.4,0.4,0.8,0.5l0.1,14.7 c0,0.4-0.4,0.4-0.5,0.8l-55.4,0.8C112,159.8,111.6,159.8,111.6,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#191519"
    },
    d: "M172.2,207.9c-2-2.3-2.6-5.4-1.9-8.3l5.4-24.7l1.8,0.1l-5.4,24.7c-0.7,2.6,0,4.8,1.6,7.1 c2,1.9,4.1,2.9,6.7,2.7l28.1-0.4c2.6-0.3,4.9-1.4,6.3-3.4c1.9-2,2-4.6,1.5-7.2l-6.1-20.4l1.4-0.3l6.1,20.8c0.7,2.6,0,6-1.5,8.6 c-1.9,2.5-4.6,4-7.6,4.1l-28.1-0.1C177.1,211.3,174.7,209.8,172.2,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAA5AA"
    },
    d: "M217.6,131.5c-1.9,2-5.6,4.8-7.8,10.2c-4.2,10.1-0.7,19.3,0.4,21.3l4.8,4.8l8-35.7 C220.6,131.7,218.8,132,217.6,131.5z M175.2,169.6c-3.3,3.1,0,6,0,6l36-0.5l-0.3-7.4C210.8,167.7,178.5,167.3,175.2,169.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178904550637329978640000005875049285856569985_",
    gradientUnits: "userSpaceOnUse",
    x1: -5448.3965,
    y1: -703.8485,
    x2: -5431.9604,
    y2: -703.8485,
    gradientTransform: "matrix(-0.9998 1.485565e-02 -1.485565e-02 -0.9998 -5243.6587 -454.1189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178904550637329978640000005875049285856569985_)"
    },
    d: "M199.5,175.5l-0.1,1.2 c4.2,1.2,8.4,1.9,12.8,2.7c1.2-3.8,2.3-8,3.5-11.9l-6.5-9.5c-1,0.4-1.4,0.8-2.3,1.1c1.1,3.1,2.6,5.9,4.5,8.6 c-0.7,2.6-1.2,5-1.9,7.6l-8.7,0.1L199.5,175.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005261770159109389540000007705464659469144967_",
    gradientUnits: "userSpaceOnUse",
    x1: -5441.7275,
    y1: -699.518,
    x2: -5409.2949,
    y2: -699.518,
    gradientTransform: "matrix(-0.9998 1.485565e-02 -1.485565e-02 -0.9998 -5243.6587 -454.1189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    style: {
      stopColor: "#312B30"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#191519"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005261770159109389540000007705464659469144967_)"
    },
    d: "M176.4,159c-0.4-1-0.3-2.2-0.1-3 c0.5-1.6,1.5-2.9,1.9-2.9c1.4-0.8,2.7-1.1,3.1-1.1c1.2,0.1,10.4,0.4,14.6,0.7c1.8,0.1,2.6,0.3,3.4,0.3c3-0.1,4.6,1.2,4.6,1.2 l4.4,4.2l-1,1.2l-4.4-4.6c0,0-1.2-1-3.4-0.7c-0.4-0.4-1.8-0.1-3.4-0.3c-1.8-0.1-4.4-0.4-9.5-0.3c-1.8-0.1-3.4-0.3-5.6-0.4 c-0.4,0-1.8,0.7-2.7,1.9c-0.5,0.8-1.1,2-0.7,3.4l8.4,18c0,0,0,0.4-0.5,0.8c-0.4,0.4-0.8-0.1-0.8-0.1L176.4,159z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAA5AA"
    },
    d: "M166.1,142.9c0.8,0.1,1.8-0.7,1.9-2c0.1-0.8-0.7-1.8-2-1.9l-22.1,0.4l-4.4-21.5 c-0.3-1.4-1.1-1.8-2-1.5c-1.4,0.3-1.8,1.1-1.5,2l4.6,22.9c-0.1,0.8,0.8,1.4,1.6,1.4L166.1,142.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M164.4,212.8l-0.7-56.3l3.4-0.1l0.7,56.3c-0.1,0.8-0.5,1.6-1.4,1.6H166 C165.1,214.2,164.7,213.8,164.4,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#312B30"
    },
    d: "M115.9,159.3l-0.1-15.1c0-0.4,0.4-0.4,0.5-0.8l55.4-0.8c0.4,0,0.4,0.4,0.8,0.5l0.1,15.1 c0,0.4-0.4,0.4-0.5,0.8l-55.9,0.7C115.9,159.7,115.9,159.7,115.9,159.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.300958ec.svg";
export { ForwardRef as ReactComponent };